import {useMemo} from 'react';

import {
  expressSelectedItemsLocalStorage,
  regularSelectedItemsLocalStorage,
  storePickupSelectedItemsLocalStorage
} from 'utils/LocalStorage';

import {AppMode} from '../constants';
import {useAppMode} from './useAppMode';

export function useSelectedItemsLocalStorage() {
  const {appMode} = useAppMode();
  const selectedItemsLocalStorage = useMemo(() => {
    switch (appMode) {
      case AppMode.express:
        return expressSelectedItemsLocalStorage;
      case AppMode.regular:
        return regularSelectedItemsLocalStorage;
      case AppMode.storePickup:
        return storePickupSelectedItemsLocalStorage;
    }
  }, [appMode]);

  return selectedItemsLocalStorage;
}
